import QueryBuilder from 'utils/fieldTypes/QueryBuilder'

export default class DatasourceQueryBuilder extends QueryBuilder {
  filterTypes = ['is', 'is_not', 'exists', 'exists_not']
}
